module.exports = __webpack_public_path__ + "static/media/ic_search.4b7599af.svg";